import { React, useState, useCallback, useEffect } from "react";
import styles from "../Home.module.css";
import { EnhancedStockTable } from "../components/EnhancedStockTable/EnhancedStockTable";
import { DEFAULT_LISTING_SORT_MODEL } from "../utils/listingDefaults";
import StockFilters from "../components/StockFilters/StockFilters";
import { Snackbar, Alert } from "@mui/material";
import { addMonths } from 'date-fns';

export const DatePage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState({
        releaseDateFrom: addMonths(new Date(), -12),
        releaseDateTo: new Date()
    });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const handleSearch = (term) => {
        setSearchTerm(term);
    };

    const handleFiltersChange = useCallback((newFilters) => {
        setFilters(newFilters);
    }, []);

    const handleClearFilters = useCallback(() => {
        setFilters({
            releaseDateFrom: addMonths(new Date(), -12),
            releaseDateTo: new Date()
        });
    }, []);

    useEffect(() => {
        const handleShowSnackbar = (event) => {
            const { message, severity } = event.detail;
            setSnackbar({ open: true, message, severity });
        };

        window.addEventListener('show-snackbar', handleShowSnackbar);
        return () => window.removeEventListener('show-snackbar', handleShowSnackbar);
    }, []);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <div className={styles.container}>
            <StockFilters
                filters={filters}
                onFiltersChange={handleFiltersChange}
                onClearFilters={handleClearFilters}
                onSearch={handleSearch}
                showManufacturer={false}
                showPrice={false}
                showAvailability={false}
                showDateRange={true}
            />

            <EnhancedStockTable 
                filters={filters}
                searchTerm={searchTerm}
                displayMode="cards"
                initialSortModel={DEFAULT_LISTING_SORT_MODEL}
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};
